import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { CheckoutContext, CheckoutContextProps } from '../../../context/CheckoutContext';
import useDfcSurface from '../../../hooks/useDfcSurface';
import { CLUB15_EMPHASIS_CLASS, isClub15Company } from '../../../Utils/club15Brand';
import { BracketWord } from '../../../pages/Home/FitnessVillageHome/asaHomeStyle';

/** Club 15's emphasis word: Playfair Display italic (the face is set by `club15Brand.ts`). */
const Club15Em = styled('em', {
  shouldForwardProp: prop => prop !== 'tone',
})<{ tone: string }>`
  font-size: 1.08em;
  color: ${({ tone }) => tone};
`;

interface EmphasisWordProps {
  children: string;
}

/**
 * The highlighted word in a heading. ASA: the word in square brackets on its royal-blue band
 * (`BracketWord`), exactly as before. Club 15: the word in italic, in the accent colour, as
 * club15.ae sets "15." (coral on cream 4.70:1, sand on charcoal 8.57:1).
 */
const EmphasisWord: React.FC<EmphasisWordProps> = ({ children }) => {
  const { company } = useContext(CheckoutContext) as CheckoutContextProps;
  const surface = useDfcSurface();
  if (isClub15Company(company)) {
    return (
      <Club15Em className={CLUB15_EMPHASIS_CLASS} tone={surface.accentText}>
        {children}
      </Club15Em>
    );
  }
  return <BracketWord>[{children}]</BracketWord>;
};

export default EmphasisWord;
